import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import CartRecoverySimulation from '../common/CartRecoverySimulation'; // Corrected import path

const { FiShoppingCart, FiArrowRight, FiTrendingDown, FiClock, FiCheck, FiStar, FiPlay } = FiIcons;

const HeroSection = () => {
  const handleCTAClick = () => {
    window.open('https://app.noem.ai/cb/growthshop', '_blank');
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-950 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 via-transparent to-blue-900/20 animate-pulse"></div>
      </div>

      <div className="relative container mx-auto px-6 py-20 min-h-screen flex items-center">
        <div className="grid lg:grid-cols-2 gap-12 items-center w-full max-w-7xl">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-white space-y-8"
          >
            {/* Main Headline */}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-5xl md:text-7xl font-black leading-tight tracking-tight"
            >
              Stop Losing{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-pink-400">
                67% of Your Customers.
              </span>{' '}
              <span className="block text-4xl md:text-5xl mt-4 text-emerald-400">
                Start Recovering $5,000+ in Lost Sales Every Month.
              </span>
            </motion.h1>

            {/* Subheadline */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-xl md:text-2xl text-gray-300 leading-relaxed font-medium"
            >
              Get a <span className="text-white font-bold">Done-For-You AI Sales Assistant</span> that recovers abandoned carts, answers customer questions, and closes sales 24/7—without you lifting a finger.
            </motion.p>

            {/* Main CTA */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="space-y-4"
            >
              <motion.button
                onClick={handleCTAClick}
                whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }}
                whileTap={{ scale: 0.95 }}
                className="group relative w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-black font-black py-6 px-8 rounded-2xl text-xl shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer"
              >
                <span className="relative z-10 flex items-center justify-center gap-3">
                  <span>BOOK A FREE DEMO</span>
                  <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-2 transition-transform text-2xl" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </motion.button>

              <div className="text-center">
                <button
                  onClick={handleCTAClick}
                  className="text-gray-300 hover:text-white transition-colors text-sm underline"
                >
                  Or, see our limited-time Black Friday pricing
                </button>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Side - Live Simulation */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="relative"
          >
            {/* --- RENDER THE NEW SIMULATION COMPONENT --- */}
            <CartRecoverySimulation />
          </motion.div>
        </div>
      </div>

      {/* Trust Strip */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1 }}
        className="absolute bottom-0 left-0 right-0 bg-black/50 backdrop-blur-lg border-t border-white/10"
      >
        <div className="container mx-auto px-6 py-4">
          <div className="flex flex-wrap items-center justify-center gap-8 text-gray-400 text-sm">
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiCheck} className="text-emerald-400" />
              <span>7-Day Setup</span>
            </div>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiCheck} className="text-emerald-400" />
              <span>30-Day Guarantee</span>
            </div>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiCheck} className="text-emerald-400" />
              <span>Works with Shopify/WooCommerce</span>
            </div>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiCheck} className="text-emerald-400" />
              <span>24/7 Support</span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;